const options = {
  5: "bg-violet-900/5",
  10: "bg-violet-900/10",
  25: "bg-violet-900/25",
  50: "bg-violet-900/50",
  75: "bg-violet-900/75",
  90: "bg-violet-900/90",
  100: "bg-violet-900",
};

const from = {
  5: "from-violet-900/5",
  10: "from-violet-900/10",
  25: "from-violet-900/25",
  50: "from-violet-900/50",
  75: "from-violet-900/75",
  90: "from-violet-900/90",
  100: "from-violet-900",
};

export default function getBackgroundViolet900(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
